
import { Box, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import { Button } from 'evee-ui-common/components/base';
import LazyContent from 'evee-ui-common/components/base/content/LazyContent';
import { formatPriceNumber } from 'evee-ui-common/utils';
import useRegion from 'store/modules/app/hooks/useRegion';

import styles from './styles';

const ListYourCar = ({ classes }) => {
  const { currency } = useRegion();

  const titleJsx = (
    <>
      Ready to rent out
      <br />
      your electric car?
    </>
  );

  const subtitleJsx = (
    <>
      Earn up to {formatPriceNumber(2000)} {currency.id}/month by sharing your car with others
    </>
  );

  return (
    <LazyContent>
      <Box className={classes.container}>
        <Box className={classes.leftColumn}>
          <Box maxWidth="300px">
            <Typography paragraph className={classes.title}>
              {titleJsx}
            </Typography>

            <Typography paragraph className={classes.subtitle}>
              {subtitleJsx}
            </Typography>

            <Button
              text="Rent out your EV"
              size="large"
              color="primary"
              component={NavLink}
              to="/car-host"
              style={{ width: '180px' }}
            />
          </Box>
        </Box>
      </Box>
    </LazyContent>

  );
};

ListYourCar.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
    leftColumn: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
  }).isRequired,
};

ListYourCar.defaultProps = {};

export default withStyles(styles)(ListYourCar);
